import { BaseQueryApi } from "@reduxjs/toolkit/dist/query";
import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";


export const getDefaultHeaders = (
  headers: Headers,
  endpoints:
    | undefined
    | Pick<BaseQueryApi, "type" | "getState" | "extra" | "endpoint" | "forced">,
  accessToken?: string | undefined
) => {
  headers.set("Accept", "application/json;charset=UTF-8");
  
  // Add Accept-Language header with current i18n language
  const currentLanguage = i18n.language || 'he'; // fallback to Hebrew if no language is set
  headers.set("Accept-Language", currentLanguage);
  headers.set("X-App-Name", 'admin');
  
  if (!headers.has("Content-Type") && endpoints?.endpoint !== "postFile" && endpoints?.endpoint !== "postVideo") {
    headers.set("Content-Type", "application/json");
  }
  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }
  return headers;
};
